import Claw from 'vueclaw'

export default {
  Claw
}
